import './index.css';
import * as TYPE from './types';
import * as CONST from './constants';
import * as UTIL from './utils';
import * as ANIMATE from './animate';
import * as _ from 'lodash-es';
import CRT from './crt';
import OV from './contest/1/overview.json';

const CRT1 = new CRT('#crt-0', OV);

window['toggleAnimation'] = (toDate, isBack) => {
  let morphArgs = [OV, isBack ? CRT1.rawData : toDate];

  isBack && morphArgs.reverse();

  const [bd0, bd1] = morphArgs.map(UTIL.convertData).map(UTIL.balanceData);
  const morphData0 = ANIMATE.morph(bd0, bd1, 0);
  const morphData1 = ANIMATE.morph(bd0, bd1, 1);

  ANIMATE.animatePath(CRT1.viewPaths[0], morphData0[0], morphData0[1]);
  ANIMATE.animatePath(CRT1.viewPaths[1], morphData1[0], morphData1[1]);
  ANIMATE.animatePath(CRT1.minimapPaths[0], morphData0[0], morphData0[1]);
  ANIMATE.animatePath(CRT1.minimapPaths[1], morphData1[0], morphData1[1]);

  setTimeout(() => {
    CRT1.constructor('#crt-0', morphArgs[1], { isInjected: !isBack });
    CRT1.wrapperEl.classList[isBack ? 'add' : 'remove']('in-minimap');
    // isBack ? CRT1.zoomTo(0, 100) : CRT1.zoomTo(40.5, 55.5);
  }, parseInt(UTIL.getVar('--anim-dur')));
};

window['zoomTo'] = (hvrIndex) => {
  const CL: any = CRT1.wrapperEl.classList.value.split(' ');

  if (!CL.includes('in-minimap')) {
    return false;
  }

  const selectedDate = new Date(CRT1.apiData.xs[hvrIndex])
    .toISOString()
    .split('T')[0]
    .split('-');

  import(`./data/1/${selectedDate[0]}-${selectedDate[1]}/${
    selectedDate[2]
  }.json`).then((response) =>
    window['toggleAnimation'](response.default, false)
  );
};

window['toggleTheme'] = () => {
  const root = document.documentElement;
  const currentTheme = UTIL.getVar('--theme_name') || 'light';
  const nextTheme = currentTheme === 'light' ? 'dark' : 'light';

  Object.keys(CONST.themePresets[nextTheme]).forEach((varName) =>
    root.style.setProperty(varName, CONST.themePresets[nextTheme][varName])
  );
};

window['toggleTheme']();
